<template>
  <div class="options-row row BoxStyle" :class="[{'RemoveControl':clicked!==-1}]">
    <div class="col-12 text-center HeaderPositionQuestion">
      <h1 id="questionTitle" class="redText main-title" :class="['fade', {'fade-in':question}]">
        Find the character for ‘six’
        <img
          class="x-btn"
          style="cursor: pointer;float: right"
          @mouseenter="buttonHover"
          :src="require(`@/assets/img/Question.png`)"
          alt
          @click="closeClick"
        />
      </h1>
    </div>
    <div
      class="col-4 mx-2 mt-3 fade options image"
      style="transition: all 0.6s ease!important;"
      v-for="(i, index) in list"
      :key="i"
      :class="[{'fade-in':images,'active': active === i,
                                'RemoveAnimation':clicked !== -1 &&  clicked !== index ,
                  'clicked hinted': clicked === index && ShowMe!== true,
                  'move-right': ( ( (clicked===2 && index===1) || (clicked===1 && index===2 ) || (clicked===0 && index===2 ) ) && ShowMe!== true ),
                  'move-left': ( ( (clicked===2 && index===0) || (clicked===1 && index===0 ) || (clicked===0 && index===1 ) ) && ShowMe!== true),
                  },
                   `index-${list.length===1?1:index}`,
                    `${ControlToShow(index)}`,
                   `l2q5option-${i}`]"
    >
      <template v-if="index===1">
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
          :style="{
            top: i===2 ? '-5px' : '0px'
          }"
        />
      </template>
      <template v-else>
        <v-img
          :src="require(`./images/${i}.png`)"
          @mouseenter="mouseover(i)"
          @mouseleave="mouseleave()"
          @click="imgClick(i, index)"
          :style="{
            top: i===2 ? '-5px' : '0px'
          }"
        />
      </template>
      <template v-if="i===2">
        <div
          class="wrong"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            left: '-12%',
            top: '21%',
            
          }"
        ></div>
      </template>

      <template v-if="i===3">
        <div
          class="wrong"
          v-if="wrongShow===true && list[clicked] === i"
          :style="{
            left: '-13%',
            top: '4%',
            
          }"
        ></div>
      </template>
      <template v-if="i===2 && pregress">
        <img alt="dash.png" src="./images/2-top.svg" class="fork fork1" />
        <img alt="dash.png" src="./images/2-center.svg" class="fork fork2" />
        <img alt="dash.png" src="./images/2-right.svg" class="fork fork3" />
        <img alt="dash.png" src="./images/2-left.svg" class="fork fork4" />
      </template>
      <template v-if="i===3 && pregress">
        <img alt="dash.png" src="./images/3-top-right.png" class="part part1" />
        <img alt="dash.png" src="./images/3-bottom.png" class="part part2" />
        <img alt="dash.png" src="./images/3-top.png" class="part part3" />
        <img alt="dash.png" src="./images/hand.svg" class="part part4" />
      </template>
    </div>

    <div
      style="bottom: 10px;position: absolute;padding: 10px "
      :class="{'fade hints-row': true, 'fade-in':textBoxEnable===1, 'fade-out':textBoxEnable===2 }"
    >
      <div
        class="col-12 p-0"
        v-for="(i) in list"
        :key="i"
        :class="[{'active': active === i, }]"
        style="padding: 0"
      >
        <div v-if="textBox[i] !== ''" class="pt-5">
          <div class="pt-5 mt-4">
            <div v-if="textBox[i] !== ''" class="text-box py-3 px-3 align-center text-center">
              <p class="mb-0 mr-3">{{textBox[i]}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Question3",

  data() {
    return {
      pregress: false,
      wrongShow: false,
      ShowMe: false,
      textBoxEnable: 0,
      closeTextEnable: false,
      images: false,
      question: false,
      active: 0,
      clicked: -1,
      list: [1, 2, 3],
      textBox: {
        1: "",
        2: "",
        3: ""
      },
      hints: {
        1: "",
        2: `When these strokes are connected together, it becomes another character we’ve learned before, “big”.`,
        3: `This might be only a minor mistake. However the “dot” stroke in Chinese character should be from left to right.`
      },
      hinted: false,
      mouse_over: "/sound/new mouse over.wav"
    };
  },
  props: {
    playSound: {
      type: Function
    },
    shuffle: {
      type: Function
    },
    finish: {
      type: Function
    },
    buttonHover: {
      type: Function
    }
  },
  mounted() {
    this.images = false;
    this.list = this.shuffle(this.list);

    this.playSound(require("./sounds/2-5.wav"));
    setTimeout(() => {
      this.question = true;

      setTimeout(() => {
        this.images = true;
      }, 2000);
      setTimeout(() => {
        this.closeTextEnable = true;
        // this.playSound("/sound/textbox shows.wav");
        setTimeout(() => {
          this.closeTextEnable = false;
        }, 5000);
      }, 3000);
    }, 500);
  },
  methods: {
    closeClick() {
      if (this.ShowMe === true || this.pregress === true) {
        return;
      }
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.pregress = true;
      this.ShowMe = false;
      this.playSound("/sound/button click.wav").then(() => {
        setTimeout(() => {
          this.textBox = {
            1: "",
            2: "",
            3: ""
          };

          setTimeout(() => {
            this.clicked = this.list.indexOf(2);

            setTimeout(() => {
              this.wrongShow = true;
            }, 1300);
            this.textBox[2] = JSON.parse(JSON.stringify(this.hints[2]));
            this.hinted = true;
            this.playSound("/sound/textbox shows.wav");
            this.playSound(require("./sounds/2-52.wav")).then(() => {
              this.wrongShow = false;
              setTimeout(() => {
                this.wrongShow = true;
              }, 400);
              setTimeout(() => {
                this.playSound("/sound/textbox shows.wav");
                // this.list = [1, 3, 2];

                this.clicked = this.list.indexOf(3);

                this.textBox[2] = "";
                this.textBox[3] = JSON.parse(JSON.stringify(this.hints[3]));
                this.playSound(require("./sounds/2-53.wav")).then(() => {
                  const parts = document.getElementsByClassName("part");


                  setTimeout(() => {
                    parts.forEach(part => {
                      part.classList.toggle("fork");
                    });
                  }, 4000);
                  setTimeout(() => {
                    this.wrongShow = false;
                    this.playSound("/sound/correct answer.wav");
                    this.textBox = {
                      1: "",
                      2: "",
                      3: ""
                    };
                    this.list = [3, 1, 2];
                    this.clicked = this.list.indexOf(1);

                    parts.forEach(part => {
                      part.classList.remove("fork");
                    });
                    setTimeout(() => {
                      this.hinted = false;
                      // this.start = false
                      // this.end = false
                      this.textBoxEnable = 0;
                      this.list = this.shuffle(this.list);
                      this.pregress = false;
                      this.active = 0;
                      this.ShowMe = false;
                      this.clicked = -1;
                    }, 3000);
                  }, 6000);
                });
              }, 3000);
            });

            this.textBoxEnable = 1;
          }, 50);
        });
      }, 1000);
    },
    mouseleave() {
      this.active = 0;
    },
    mouseover(i) {
      if (this.clicked !== -1 || this.ShowMe) {
        return;
      }
      this.active = i;
      this.playSound(this.mouse_over);
    },
    ControlToShow(i) {
      if (this.ShowMe) {
        if (i === 0) {
          return "RemoveAnimation";
        }
        if (i === 2) {
          return "RemoveAnimation";
        }
      } else {
        return "Scale1";
      }
      return "";
    },
    closeTextBox() {
      this.textBoxEnable = 2;
      this.hinted = false;
      setTimeout(() => {
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        this.textBoxEnable = 0;
        this.clicked = -1;
      }, 1000);
    },
    imgClick(i, index) {
      if (this.clicked !== -1 || this.ShowMe || this.pregress === true) {
        return;
      }
      this.pregress = true;

      setTimeout(() => {
        this.hinted = false;
        this.clicked = index;
        this.textBox = {
          1: "",
          2: "",
          3: ""
        };
        if (i === 1) {
          setTimeout(() => {
            this.pregress = false;
            this.closeTextBox();
          }, 3000);
          this.playSound("/sound/correct answer.wav");
          this.finish();
        } else {
          setTimeout(() => {
            this.wrongShow = true;
          }, 1900);

          setTimeout(() => {
            this.wrongShow = false;
          }, 6000);
          this.playSound("/sound/highlight.wav");

          this.clicked = index;
          if (i === 2) {
            this.textBox[i] = this.hints[i];
            this.playSound(require("./sounds/2-52.wav")).then(() => {
              setTimeout(() => {
                this.clicked = -1;
                this.textBox = {
                  1: "",
                  2: "",
                  3: ""
                };
                this.pregress = false;
              }, 2500);
            });
          } else {
            this.textBox[i] = this.hints[i];
            this.playSound(require("./sounds/2-53.wav")).then(() => {
              const parts = document.getElementsByClassName("part");

              setTimeout(() => {
                parts.forEach(part => {
                  part.classList.add("fork");
                });
              }, 4000);
              setTimeout(() => {
                this.clicked = -1;
                this.textBox = {
                  1: "",
                  2: "",
                  3: ""
                };
                parts.forEach(part => {
                  part.classList.remove("fork");
                });
                this.pregress = false;
              }, 6500);
            });
          }
          setTimeout(() => {
            this.playSound("/sound/textbox shows.wav");
            this.textBoxEnable = 1;
          }, 1000);
          setTimeout(() => {}, 1000);
          if (index != 1) {
            console.log(index);
          }
        }
      }, 200);
    }
  }
};
</script>

<style lang="scss">
.l2q5option-2 {
  .fork {
    position: absolute;
    top: 13%;
    left: 70%;
    width: 53%;
    opacity: 0;
  }

  .fork1 {
    top: 13.5%;
  }

  .fork3,
  .fork4 {
    top: 12.5%;
  }

  .v-image {
    left: 0;

    /*opacity: 0;*/
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: left 2s;
      left: -50%;

      /*opacity: 0;*/
    }

    .fork {
      animation: fadeIn 1s 4s forwards;
      transition: all 2s;
      transition-delay: 6s;
    }

    .fork1 {
      top: 7%;
    }

    .fork3,
    .fork4 {
      top: 19%;
    }

    .fork3 {
      left: 75%;
    }

    .fork4 {
      left: 65%;
    }
  }
}

.l2q5option-3 {
  .part {
    position: absolute;
    top: 15%;
    left: 70%;
    width: 53%;
    opacity: 0;
    transition: all 2s;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }

  .part3 {
    left: 85%;
    top: 20%;
    width: 53%;
    transform: rotate(-25deg);
    height: 0%;
  }

  .part4 {
    left: 106%;
    top: -18%;
  }

  .v-image {
    left: unset;
  }

  &.hinted {
    .v-image {
      transition-delay: 4s;
      transition: all 2s;
      left: -50%;
      /*opacity: 0;*/
    }

    .part {
      transition-delay: 4s;
      opacity: 1;
    }

    .part2 {
      animation: fadeOut 2s 5s forwards;
    }

    .part1 {
      animation: flashing_long_5 6s 4s forwards;
    }

    .part3 {
      transition: all 2s;
      transition-delay: 10s;

      height: 70%;
      top: 13%;
      left: 92%;
    }
    .part4 {
      transition: all 2s;

      transition-delay: 10s;

      left: 110%;
      top: -4%;
    }
    .fork {
      opacity: 0;
      transition-delay: 0s;
    }
  }
}

@keyframes flashing_long_5 {
  0% {
    opacity: 0;
  }
  
  35% {
    opacity: 1;
  }
  65% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}
</style>